<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-awsGoodsReview',
  components: { PageTable },
}
</script>
